module.exports = __webpack_public_path__ + "static/aha-share-d880d2a6c34afa05f76af616b44c78e8.jpg";